import { ENABLED_CIDS, ENABLED_STORES } from "./config";
import {
  FLOOR_MEN,
  FLOOR_WOMEN
} from "../../../../state/modules/config/constants";

const shouldShowPromoTile = ({
  floor,
  storeCode,
  categoryId,
  pages: [firstRenderedPage]
}) =>
  [FLOOR_MEN, FLOOR_WOMEN].includes(floor) &&
  ENABLED_CIDS.includes(categoryId) &&
  ENABLED_STORES.includes(storeCode) &&
  firstRenderedPage?.pageNumber === 1;
export default shouldShowPromoTile;
